import React from "react"

export const SolanaModalContext = React.createContext()
